import { HeaderCellProps } from '../../types';
import { Tooltip } from '@mui/material';

const TotalAvailableForImportsHeaderCell = ({
  _customRowProps: { integration },
}: HeaderCellProps) => {
  return (
    <Tooltip title="Total available entities that can be synced on the integration server">
      <div>Total Available for Import (On Integration Server)</div>
    </Tooltip>
  );
};

export default TotalAvailableForImportsHeaderCell;
